export default __webpack_public_path__ + "static/media/goods-cart.16c506e4.png";